import axios from "axios";
import React, { useState } from "react";
import { BASEURL, successToast } from "../utils/utils";
import { useNavigate } from "react-router-dom";

const Project = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("mint 2");
  const [description, setDescription] = useState("this is description");
  const [price, setPrice] = useState(131);
  const [link, setLink] = useState("google.com");
  const [availableSpots, setAvailableSpots] = useState(12);
  const [startDate, setStartDate] = useState("2022-05-20");
  const [endDate, setEndDate] = useState("2022-06-20");
  const [maxEntries, setMaxEntries] = useState(12);
  const [mintTime, setMintTime] = useState("2022-06-20");
  const [image, setImage] = useState("");

  const handleSaveProject = async () => {
    var formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    formData.append("price", price);
    formData.append("link", link);
    formData.append("availableSpots", availableSpots);
    formData.append("startDate", startDate);
    formData.append("endDate", endDate);
    formData.append("maxEntries", maxEntries);
    formData.append("mintTime", mintTime);
    formData.append("image", image);

    axios
      .post(BASEURL + "/project/", formData)
      .then((res) => {
        console.log(res);
        successToast("Project added Successfully");
        navigate("/all");
      })
      .catch((e) => console.log(e));
  };

  const handleValidation = () => {
    if (
      !name ||
      !description ||
      !link ||
      !price ||
      !availableSpots ||
      !startDate ||
      !endDate ||
      !mintTime ||
      !image
    )
      return true;
    return false;
  };

  return (
    <div className="my-4">
      <div className="shadow-lg bg-[#FAFAFB] max-w-[90%] p-5 m-auto">
        <p className="my-3 text-lg font-bold">Add Project</p>
        <div className="flex flex-wrap justify-start">
          <div className="my-2 w-[360px] mx-2">
            <label
              class="block text-gray-700 text-md font-bold mb-2"
              for="Name"
            >
              Name
            </label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="Name"
              type="text"
              placeholder="Name"
            />
          </div>
          <div className="my-2 w-[360px] mx-2">
            <label
              class="block text-gray-700 text-md font-bold mb-2"
              for="Description"
            >
              Description
            </label>

            <input
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="Description"
              type="text"
              placeholder="Description"
            />
          </div>
          <div className="my-2 w-[360px] mx-2">
            <label
              class="block text-gray-700 text-md font-bold mb-2"
              for="Link"
            >
              Link
            </label>

            <input
              value={link}
              onChange={(e) => setLink(e.target.value)}
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="Link"
              type="text"
              placeholder="Link"
            />
          </div>
          <div className="my-2 w-[360px] mx-2">
            <label
              class="block text-gray-700 text-md font-bold mb-2"
              for="Price"
            >
              Price
            </label>

            <input
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="Price"
              type="text"
              placeholder="Price"
            />
          </div>
          <div className="my-2 w-[360px] mx-2">
            <label
              class="block text-gray-700 text-md font-bold mb-2"
              for="AvailableSpots"
            >
              Available Spots
            </label>

            <input
              value={availableSpots}
              onChange={(e) => setAvailableSpots(e.target.value)}
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="AvailableSpots"
              type="text"
              placeholder="Available Spots"
            />
          </div>
          <div className="my-2 w-[360px] mx-2">
            <label
              class="block text-gray-700 text-md font-bold mb-2"
              for="StartDate"
            >
              Start Date
            </label>

            <input
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="StartDate"
              type="text"
              placeholder="Start Date"
            />
          </div>
          <div className="my-2 w-[360px] mx-2">
            <label
              class="block text-gray-700 text-md font-bold mb-2"
              for="EndDate"
            >
              End Date
            </label>

            <input
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="EndDate"
              type="text"
              placeholder="End Date"
            />
          </div>
          <div className="my-2 w-[360px] mx-2">
            <label
              class="block text-gray-700 text-md font-bold mb-2"
              for="MaxEntries"
            >
              Max Entries
            </label>
            <input
              value={maxEntries}
              onChange={(e) => setMaxEntries(e.target.value)}
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="MaxEntries"
              type="text"
              placeholder="Max Entries"
            />
          </div>
          <div className="my-2 w-[360px] mx-2">
            <label
              class="block text-gray-700 text-md font-bold mb-2"
              for="MintTime"
            >
              Mint Time
            </label>
            <input
              value={mintTime}
              onChange={(e) => setMintTime(e.target.value)}
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="MintTime"
              type="text"
              placeholder="Mint Time"
            />
          </div>
          <div className="my-2 w-[360px] mx-2">
            <label
              class="block text-gray-700 text-md font-bold mb-2"
              for="MintTime"
            >
              Image
            </label>
            <input
              onChange={(e) => setImage(e.target.files[0])}
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="MintTime"
              type="file"
              placeholder="Mint Time"
            />
          </div>
        </div>
        <div className="flex justify-end mt-3 mx-3">
          <button
            disabled={handleValidation()}
            onClick={handleSaveProject}
            className=" bg-[color:var(--purple-color)] px-4 py-2 rounded-lg border-none text-white"
          >
            Save Project
          </button>
        </div>
      </div>
    </div>
  );
};

export default Project;
